<template>
  <div><PageTable /></div>
</template>

<script>
import PageTable from './components/table'
export default {
  name: 'inspection-defects',
  components: { PageTable },
}
</script>
